<template>
  <!--    :close-on-press-escape="closeOnPressEscape"-->
  <div :key="key">
    <el-dialog
      :visible="visible"
      :title="title"
      :modal="modal"
      :modal-append-to-body="modalAppendToBody"
      :append-to-body="appendToBody"
      :lock-scroll="lockScroll"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="false"
      :show-close="false"
      :width="width"
      :fullscreen="mFullscreen"
      :custom-class="customClass"
      :top="top"
      :before-close="beforeClose"
      :center="center"
      :destroy-on-close="destroyOnClose"
      @open="handleOpen"
      @opend="handleOpend"
      @close="handleClose"
      @closed="handleClosed"
      :class="{'approvalOrder':ceiling}"
    >
      <div slot="title" class="dialog-header">
        <slot name="title">
          <span class="el-dialog__title">{{ title }}</span>
        </slot>
        <slot name="header"></slot>
        <div>
          <slot name="headerBtn"></slot>
          <button
            type="button"
            class="el-dialog__headerfullbtn"
            aria-label="Fullscreen"
            @click="
              () => {
                mFullscreen = !mFullscreen;
              }
            "
          >
            <el-tooltip
              :enterable="false"
              effect="dark"
              :content="mFullscreen ? '还原' : '最大化'"
              placement="bottom"
            >
              <i class="el-icon-full-screen"></i>
              <!-- <svg-icon
                style="color: #909399"
                :icon-class="mFullscreen ? 'el-icon-full-screen' : 'el-icon-full-screen'"
              />-->
            </el-tooltip>
          </button>
          <button
            type="button"
            class="el-dialog__headerfullbtn"
            aria-label="Close"
            v-if="showClose"
            @click="handleCloses"
          >
            <el-tooltip effect="dark" content="关闭" placement="bottom">
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </el-tooltip>
          </button>
        </div>
      </div>
      <slot></slot>
      <slot slot="footer" name="footer"></slot>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'MDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },

    modal: {
      type: Boolean,
      default: true,
    },

    modalAppendToBody: {
      type: Boolean,
      default: true,
    },

    appendToBody: {
      type: Boolean,
      default: false,
    },

    lockScroll: {
      type: Boolean,
      default: true,
    },

    closeOnClickModal: {
      type: Boolean,
      default: false,
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },

    showClose: {
      type: Boolean,
      default: true,
    },

    width: {
      type: String,
      default: undefined,
    },

    fullscreen: Boolean,

    ceiling: {
      type: Boolean,
      default: false,
    },

    customClass: {
      type: String,
      default: '',
    },

    top: {
      type: String,
      default: '15vh',
    },
    beforeClose: {
      type: Function,
      default: undefined,
    },
    center: {
      type: Boolean,
      default: false,
    },
    //关闭时销毁组件
    destroyOnClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // mVisible: this.visible,
      mFullscreen: this.fullscreen,
      lockTop: false,
      key: 0,
    }
  },
  watch: {
    // visible(n) {
    //   this.mVisible = n
    //   if (!n) {
    //     // this.$emit('update:visible', false)
    //     // this.$emit('close1')
    //   }
    // },
    mFullscreen(n) {
      this.$emit('update:fullscreen', n)
    },
    fullscreen(n) {
      this.mFullscreen = n
    },
    ['top']: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.visible == true) {
          this.handleSetProperty(newVal)
        }
      },
    },
  },
  methods: {
    handleOpen() {
      this.$emit('open')
    },
    handleOpend() {
      this.$emit('opend')
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')

      if (this.destroyOnClose) {
        this.$nextTick(() => {
          this.key++
        })
      }
    },
    handleCloses() {
      this.$emit('update:visible', false)
      this.$emit('closes')

      if (this.destroyOnClose) {
        this.$nextTick(() => {
          this.key++
        })
      }
    },
    handleClosed() {
      const top = '5vh'
      this.handleSetProperty(top)
      this.$emit('update:top', top)
      this.$emit('update:visible', false)
      this.$emit('closed')

      if (this.destroyOnClose) {
        this.$nextTick(() => {
          this.key++
        })
      }
    },
    handleSetProperty(top) {
      document.documentElement.style.setProperty('--vtop', `${top}`)
    },
  },
}
</script>
<style lang='less' scoped>
@import '~@/assets/variables.less';
.el-icon-full-screen {
  font-size: 16px;
}
/deep/ .el-dialog__footer {
  font: menu;
}
/deep/ .line-button {
  background-color: #c59429;
  color: #ffffff;
  border-color: #c59429;
  border-radius: @btn-radius-size;
  margin-left: 20px;
}
/deep/ .batch-button {
  margin-left: 20px;
  background-color: #ffffff;
  color: #000;
  border-color: #d9d7d7;
  border-radius: @btn-radius-size;
  margin-left: 0;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.el-dialog__headerfullbtn {
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  width: 28px;
}

.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
  color: #2f4cdd !important;
}

::v-deep {
  .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
  .el-dialog__footer {
    // height: 55px;
  }
  .el-dialog {
    border-radius: @dialog-radius-size;
    //margin-top: 5vh !important;
  }

  .el-dialog__header {
    border-bottom: 1px solid #e0e0e0;
    padding: 10px;
    font-size: 20px;
    font-weight: 700;
  }
  .el-dialog__footer {
    border-top: 1px solid #e0e0e0;
  }
}
::v-deep {
  .el-dialog__body {
    padding: 20px 20px;
  }
}
.big {
  ::v-deep {
    .el-dialog {
      border-radius: @dialog-radius-size;
      margin-top: 0;
    }

    .el-dialog__footer {
      border-top: 1px solid #e0e0e0;
    }
  }
}
</style>
